<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.manageCertifications' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row">

        <div class="col-lg-12">
          <div class="alert alert-success text-center" role="alert" *ngIf="addingSuccess">
            {{messageText}}
            <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <a href="javascript:window.history.back();" class="mb-2 btn btn-primary waves-effect waves-light btn-sm mb-3"><i class="mdi mdi-chevron-left ml-1"></i> {{'common.back' | translate}} </a>

          <div class="card">
            <div class="card-body">

              <h4 class="card-title">{{'pages.addCertification' | translate}}</h4>

                <div class="form-group row">
                  <label class="col-md-2 col-form-label">{{'messages.selectType' | translate}}</label>
                  <div class="col-md-10">
                    <select class="custom-select" [(ngModel)]="certification.type">
                        <option value="1">{{'navigation.certifications' | translate}}</option>
                        <option value="0">{{'fields.subCertificate' | translate}}</option>

                    </select>
                  </div>
                </div>
                <ng-container *ngIf="certification.type == 0">
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'messages.selectCertification' | translate}}</label>
                    <div class="col-md-10">
                      <select class="custom-select" [(ngModel)]="certification.id">
                          <option *ngFor="let certificat of certificats; let i = index" [value]="certificat.id">{{certificat.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.label' | translate}}</label>
                    <div class="col-md-10">
                      <input class="form-control" type="text" [(ngModel)]="certification.name">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.description' | translate}}</label>
                    <div class="col-md-10">
                      <textarea required="" class="form-control" rows="5" [(ngModel)]="certification.description"></textarea>
                    </div>
                  </div>
                  <ng-container *ngIf="entityType == 'EKAMPUS'">
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.sites' | translate}}</label>
                    <div class="col-md-10 text-left">
                      <div class="mb-2">
                        <button type="button" class="btn btn-sm btn-outline-primary waves-effect" (click)="selectAllSites(true)">{{'common.selectAll' | translate}}</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary waves-effect ml-2" (click)="selectAllSites(false)">{{'common.deselectAll' | translate}}</button>
                      </div>
                      <ng-select [items]="sites"
                                 bindLabel="name"
                                 bindValue="id"
                                 [multiple]="true"
                                 [closeOnSelect]="false"
                                 [searchable]="true"
                                 [appendTo]="'body'"
                                 [attr.placeholder]="'export.searchSites' | translate"
                                 [(ngModel)]="selectedSiteIds">
                      </ng-select>
                    </div>
                  </div>
                  </ng-container>

                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.validity' | translate}}</label>
                    <div class="col-md-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" value="2" [(ngModel)]="readioSelected" (change)="changeValidite($event)">
                      <label class="form-check-label">
                        {{'fields.byDurationMonths' | translate}}
                      </label>
                    </div>
                    <div class="col-md-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" value="1" [(ngModel)]="readioSelected" (change)="changeValidite($event)">
                      <label class="form-check-label">
                        {{'fields.byDate' | translate}}
                      </label>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="certification.type == 1">
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.label' | translate}}</label>
                    <div class="col-md-10">
                      <input class="form-control" type="text" [(ngModel)]="certification.name">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.description' | translate}}</label>
                    <div class="col-md-10">
                      <textarea required="" class="form-control" rows="5" [(ngModel)]="certification.description"></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.articleCode' | translate}}</label>
                    <div class="col-md-10">
                      <input class="form-control" type="text" [(ngModel)]="certification.code_article">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.clientCode' | translate}}</label>
                    <div class="col-md-10">
                      <input class="form-control" type="text" [(ngModel)]="certification.code_client">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.theme' | translate}}</label>
                    <div class="col-md-10">
                      <select class="custom-select" [(ngModel)]="certification.theme">
                        <option [value]="null" disabled selected>{{'messages.selectTheme' | translate}}</option>
                        <option *ngFor="let theme of themes" [value]="theme">{{theme}}</option>
                      </select>
                    </div>
                  </div>

                  <ng-container *ngIf="entityType == 'EKAMPUS'">
                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.sites' | translate}}</label>
                    <div class="col-md-10 text-left">
                      <div class="mb-2">
                        <button type="button" class="btn btn-sm btn-outline-primary waves-effect" (click)="selectAllSites(true)">{{'common.selectAll' | translate}}</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary waves-effect ml-2" (click)="selectAllSites(false)">{{'common.deselectAll' | translate}}</button>
                      </div>
                      <ng-select [items]="sites"
                                 bindLabel="name"
                                 bindValue="id"
                                 [multiple]="true"
                                 [closeOnSelect]="false"
                                 [searchable]="true"
                                 [appendTo]="'body'"
                                 [attr.placeholder]="'export.searchSites' | translate"
                                 [(ngModel)]="selectedSiteIds">
                      </ng-select>
                    </div>
                  </div>
                  </ng-container>

                  <div class="form-group row">
                    <label class="col-md-2 col-form-label">{{'fields.validity' | translate}}</label>
                    <div class="col-md-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" value="2" [(ngModel)]="readioSelected" (change)="changeValidite($event)">
                      <label class="form-check-label">
                        {{'fields.byDurationMonths' | translate}}
                      </label>
                    </div>
                    <div class="col-md-1">
                      <input class="form-check-input" type="radio" name="exampleRadios" value="1" [(ngModel)]="readioSelected" (change)="changeValidite($event)">
                      <label class="form-check-label">
                        {{'fields.byDate' | translate}}
                      </label>
                    </div>
                  </div>

                </ng-container>

              <div class="form-group row" *ngIf="readioSelected == 1">
                <label class="col-md-2 col-form-label">{{'fields.date' | translate}}</label>
                <div class="col-md-3">
                  <input class="form-control" type="date" [(ngModel)]="certification.date">
                </div>
              </div>
              <div class="form-group row" *ngIf="readioSelected == 2">
                <label class="col-md-2 col-form-label">{{'fields.duration' | translate}}</label>
                <div class="col-md-3">
                  <input class="form-control" type="text" [(ngModel)]="certification.delay">
                </div>
              </div>
              <div class="form-group text-center" *ngIf="certification.type">
                <button type="button" class="btn btn-primary waves-effect waves-light" (click)="add_certificat()">
                  {{'common.add' | translate}}
                </button>
              </div>
            </div>
          </div>
          <!-- end row -->
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      </div>
      </div>
      </div>
      <!-- End Page-content -->
      <app-footer></app-footer>
